import { computeNutrition } from "../nutrition/NutritionOrchestrator";
import { buildPackPlan } from "./PackPlan";
import { packPlanToLineItems } from "./PackPlanToLineItems";
import { SELLING_PLANS } from "./SellingPlans";

export function buildDogSubscriptionLineItems({
  dogForm,
  recipes,
  planKey,
  totalMeals,
}: {
  dogForm: any;
  recipes: any;
  planKey: keyof typeof SELLING_PLANS;
  totalMeals: number;
}) {
  const nutrition = computeNutrition(
    {
      weightKg: dogForm.weightKg,
      ageYears: dogForm.years,
      bodyCondition: dogForm.bodyCondition,
      activityLevel: dogForm.activityLevel,
    },
    recipes,
    totalMeals
  );

  const packPlan = buildPackPlan({
    gramsPerRecipe: nutrition.gramsPerRecipe,
  });

  const lineItems = packPlanToLineItems(packPlan, SELLING_PLANS[planKey]);

  return {
    nutrition,
    packPlan,
    lineItems,
  };
}
